import { toast } from "sonner"
import { apiFetch } from "@/hooks/apiFetch"
import { queryClient } from "@/lib/queryClient"

interface ExportParams {
  startDate?: string
  endDate?: string
  reportType: string
  [key: string]: any
}

export const exportReport = async (params: ExportParams): Promise<boolean> => {
  try {
    // Convert camelCase keys to snake_case for API
    const apiParams: Record<string, any> = {}
    Object.entries(params).forEach(([key, value]) => {
      const snakeKey = key.replace(
        /[A-Z]/g,
        (letter) => `_${letter.toLowerCase()}`
      )
      apiParams[snakeKey] = value
    })

    await apiFetch("report/export", {
      method: "POST",
      body: JSON.stringify(apiParams),
    })

    queryClient.invalidateQueries({ queryKey: ["exports"] })
    toast.success(
      "Export started — download it from the Exports page once it is ready",
      {
        action: {
          label: "Open Exports",
          onClick: () => {
            window.location.href = "/pos/exports"
          },
        },
      }
    )

    return true
  } catch (error: any) {
    console.error("Export error:", error)
    toast.error(error?.message || "Failed to start export")
    return false
  }
}
